import { useEffect, useState } from "react";
import { DiscoverEventName } from "./Discover";
import { LiveEventUbInputType } from "../../gql/graphql";

const eventName = DiscoverEventName;

export function useDiscoverFromEventSource(
  eventSource: EventSource | undefined,
): {
  discoverDependencyCounter: number;
} {
  const [discoverDependencyCounter, setDiscoverDependencyCounter] =
    useState<number>(0);

  useEffect(() => {
    if (!eventSource) return;

    // attaching a handler to receive message events
    const handler = (event: MessageEvent) => {
      if (event.data === "beat") return;

      const data = JSON.parse(event.data);
      const v: LiveEventUbInputType = { ...data };

      if (v.eventName === eventName) {
        console.debug(`${v.eventName} from ${v.deviceIdentifier}`);
        setDiscoverDependencyCounter((c) => c + 1);
      }
    };

    // eventSource.onmessage = handler;
    eventSource.addEventListener("message", handler);

    return () => {
      console.debug(`Removing event source listener for ${eventName}`);
      eventSource.removeEventListener("message", handler);
    };
  }, [eventSource]);

  return { discoverDependencyCounter };
}
